import axios from "axios";
import { awsUrl, aspNetUrl, newApiBaseUrl } from "../../axiosInstance";

export const getStationsFromPGW = () => {
  return axios.get(`${newApiBaseUrl}/common/locations`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `bearer ${localStorage.jwtToken}`,
      "X-Tenant": "hamazon",
    },
  });
};

export const NewStationEdit = (data) => {
  return axios.post(`${newApiBaseUrl}/admin/locations`, data, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `bearer ${localStorage.jwtToken}`,
      "X-Tenant": "hamazon",
    },
  });
};

export const getColumns = (stationId) => {
  return axios.get(
    `${aspNetUrl}LocationColumn/GetColumns?stationId=${stationId}&all=true`,
    {
      headers: {
        Authorization: `bearer ${localStorage.token}`,
        "Access-Control-Allow-Origin": "*",
      },
    },
  );
};

export const setRowsNew = (
  StationId,
  Quantity,
  LocationColumnId,
  LocationRowId,
) => {
  return axios.post(
    `${aspNetUrl}LocationColumn/AddNewRows`,
    { StationId, Quantity, LocationColumnId, LocationRowId },
    {
      headers: {
        Authorization: `bearer ${localStorage.token}`,
        "Access-Control-Allow-Origin": "*",
      },
    },
  );
};
export const AddNewCells = (
  StationId,
  Quantity,
  LocationColumnId,
  LocationRowId,
) => {
  return axios.post(
    `${aspNetUrl}LocationColumn/AddNewCells`,
    { StationId, Quantity, LocationColumnId, LocationRowId },
    {
      headers: {
        Authorization: `bearer ${localStorage.token}`,
        "Access-Control-Allow-Origin": "*",
      },
    },
  );
};
export const setColumnsNew = (StationId, Quantity) => {
  return axios.post(
    `${aspNetUrl}LocationColumn/AddNewColumns`,
    { StationId, Quantity },
    {
      headers: {
        Authorization: `bearer ${localStorage.token}`,
        "Access-Control-Allow-Origin": "*",
      },
    },
  );
};

export const getRows = (columnId) => {
  return axios.get(
    `${aspNetUrl}LocationColumn/GetRows?columnId=${columnId}&all=true`,
    {
      headers: {
        Authorization: `bearer ${localStorage.token}`,
        "Access-Control-Allow-Origin": "*",
      },
    },
  );
};

export const geCells = (rowId) => {
  return axios.get(
    `${aspNetUrl}LocationColumn/GetCells?rowId=${rowId}&all=true`,
    {
      headers: {
        Authorization: `bearer ${localStorage.token}`,
        "Access-Control-Allow-Origin": "*",
      },
    },
  );
};

export const saveColm = (data) => {
  return axios.post(`${aspNetUrl}LocationColumn/SaveColumnInfo`, data, {
    headers: {
      Authorization: `bearer ${localStorage.token}`,
      "Access-Control-Allow-Origin": "*",
    },
  });
};
export const saveCells = (data) => {
  return axios.post(`${aspNetUrl}LocationColumn/SaveCellInfo`, data, {
    headers: {
      Authorization: `bearer ${localStorage.token}`,
      "Access-Control-Allow-Origin": "*",
    },
  });
};
export const SaveRowInfo = (data) => {
  return axios.post(`${aspNetUrl}LocationColumn/SaveRowInfo`, data, {
    headers: {
      Authorization: `bearer ${localStorage.token}`,
      "Access-Control-Allow-Origin": "*",
    },
  });
};

export const AddNewCell = (data) => {
  return axios.post(`${aspNetUrl}LocationColumn/AddNewCell`, data, {
    headers: {
      Authorization: `bearer ${localStorage.token}`,
      "Access-Control-Allow-Origin": "*",
    },
  });
};
